import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import createSimpleSelector from 'commons/utils/createSimpleSelector';
import { getStatistics } from '../statisticsSelectors';

const getSalesChannelsRevenue = createSimpleSelector(
  [getStatistics],
  (statistics) => statistics.salesChannelsRevenue,
);

export const getSalesChannelsRevenueData = createSimpleSelector(
  [getSalesChannelsRevenue],
  (salesChannelsRevenue) => salesChannelsRevenue.data,
);

export const getSalesChannelsRevenueStatus = createSimpleSelector(
  [getSalesChannelsRevenue],
  (salesChannelsRevenue) =>
    convertStatusTypeToObject(salesChannelsRevenue.status),
);
